import requests from "./httpService";

const ServiceServices = {
  createService(storeId, serviceData) {
    return requests.post(`/api/stores/${storeId}/services`, serviceData);
  },

  getServices(storeId) {
    return requests.get(`/api/stores/${storeId}/services`);
  },

  updateService(storeId, serviceId, serviceData) {
    return requests.put(
      `/api/stores/${storeId}/services/${serviceId}`,
      serviceData
    );
  },

  deleteService(storeId, serviceId) {
    return requests.delete(`/api/stores/${storeId}/services/${serviceId}`);
  },
};

export default ServiceServices;
